/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import FieldPill from './FieldPill.vue'

const __vue_script__ = {
	name: 'TemplateFieldSelectorDialog',
	components: {
		FieldPill
	},
	props: {
		quill: {
			default: null
		},
		Quill: {
			default: null
		},
		doctype: {
			default: null
		}
	},
	data() {
		return {
			fields: {},
			selectedPills: [],
			referenceDoc: null
		}
	},
	created() {
		frappe.field_selector_updates.on('reference_update', (reference) => {
			this.selectedPills = []
			this.get_fields(reference)
		})

		frappe.field_selector_updates.on('clear', () => {
			this.selectedPills = []
			this.fields = {}
		})

		frappe.field_selector_updates.on('submit', () => {
			this.add_field_to_text();
			frappe.field_selector_updates.trigger('done');
		})
	},
	mounted() {
		if (this.doctype) {
			this.referenceDoc = this.doctype;
			this.get_fields(this.doctype)
		}
	},
	methods: {
		get_fields(reference) {
			this.referenceDoc = reference;
			frappe.xcall('frappe.email.doctype.email_template.email_template.get_template_fields', {reference: reference})
			.then(e => {
				this.fields = e
			})
		},
		add_field_to_text() {
			let range = this.quill.getSelection(true);

			this.selectedPills.forEach(value => {
				this.quill.insertEmbed(
					range.index,
					'template-blot',
					{
						parent: value.parent,
						fieldname: value.fieldname,
						reference: value.reference,
						label: value.label,
						function: value.function,
						fieldtype: value.fieldtype
					}
				);

				//Add a space after the marker and take the cursor to the inserted blot
				this.quill.insertText(range.index + 1, ' ', this.Quill.sources.USER);
				this.quill.setSelection(range.index + 2, this.Quill.sources.SILENT);
				})
		},
		showReference(field) {
			return field=="name" ? true : false
		}
	}
}


/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(Object.keys(_vm.fields), function(field) {
      return _c(
        "div",
        { key: field, staticClass: "field-pill-section-wrapper" },
        [
          _c("div", { staticClass: "field-pill-title" }, [
            _c("h4", [
              _vm.showReference(field)
                ? _c("span", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.__("Reference Document : ")))
                  ])
                : field !== _vm.__("Custom Functions")
                ? _c("span", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.__("Linked Document : ")))
                  ])
                : _vm._e(),
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.__(_vm.fields[field][0]["parent"])) +
                  "\n\t\t\t\t"
              ),
              "reference_label" in _vm.fields[field][0] &&
              field !== _vm.__("Custom Functions")
                ? _c("span", { staticClass: "text-muted" }, [
                    _vm._v("(" + _vm._s(_vm.__("Field")) + "\n\t\t\t\t\t"),
                    _c("i", [
                      _vm._v(
                        _vm._s(
                          _vm.__(_vm.fields[field][0]["reference_label"])
                        ) + ")"
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-wrap border rounded field-pill-section" },
            _vm._l(_vm.fields[field], function(f) {
              return _c(
                "div",
                { key: f.fieldname, staticClass: "field-pill-wrapper" },
                [
                  _c("field-pill", {
                    attrs: {
                      label: f.label,
                      fieldname: f.fieldname,
                      fieldtype: f.fieldtype,
                      parent: f.parent,
                      reference: f.reference,
                      function: f.function,
                      selectedPills: _vm.selectedPills
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        ]
      )
    }),
    0
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5181656d_0", { source: "\n.field-pill-wrapper {\n\tmargin: 5px;\n}\n.field-pill-section {\n\tpadding: 5px 0;\n}\n.field-pill-title {\n\tpadding-left: 10px;\n}\n.field-pill-section-wrapper {\n\tmargin-top: 30px;\n}\n\n", map: {"version":3,"sources":["frappe/public/js/frappe/form/controls/template_field_selector/TemplateFieldSelector.vue"],"names":[],"mappings":";AAwHA;CACA,WAAA;AACA;AAEA;CACA,cAAA;AACA;AAEA;CACA,kBAAA;AACA;AAEA;CACA,gBAAA;AACA","file":"TemplateFieldSelector.vue","sourcesContent":["<template>\n\t<div>\n\t\t<div class=\"field-pill-section-wrapper\" v-for=\"field in Object.keys(fields)\" :key=\"field\">\n\t\t\t<div class=\"field-pill-title\">\n\t\t\t\t<h4>\n\t\t\t\t\t<span v-if=\"showReference(field)\" class=\"text-muted\">{{ __(\"Reference Document : \") }}</span>\n\t\t\t\t\t<span v-else-if=\"field!==__('Custom Functions')\" class=\"text-muted\">{{ __(\"Linked Document : \") }}</span>\n\t\t\t\t\t{{ __(fields[field][0][\"parent\"]) }}\n\t\t\t\t\t<span v-if=\"'reference_label' in fields[field][0] && field!==__('Custom Functions')\" class=\"text-muted\">({{ __(\"Field\") }}\n\t\t\t\t\t\t<i>{{ __(fields[field][0][\"reference_label\"]) }})</i>\n\t\t\t\t\t</span>\n\t\t\t\t</h4>\n\t\t\t</div>\n\t\t\t<div class=\"flex flex-wrap border rounded field-pill-section\">\n\t\t\t\t<div class=\"field-pill-wrapper\" v-for=\"f in fields[field]\" :key=\"f.fieldname\">\n\t\t\t\t\t<field-pill\n\t\t\t\t\t:label=\"f.label\"\n\t\t\t\t\t:fieldname=\"f.fieldname\"\n\t\t\t\t\t:fieldtype=\"f.fieldtype\"\n\t\t\t\t\t:parent=\"f.parent\"\n\t\t\t\t\t:reference=\"f.reference\"\n\t\t\t\t\t:function=\"f.function\"\n\t\t\t\t\t:selectedPills=\"selectedPills\"\n\t\t\t\t\t>\n\t\t\t\t\t</field-pill>\n\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</template>\n\n<script>\n\nimport FieldPill from './FieldPill.vue'\n\nexport default {\n\tname: 'TemplateFieldSelectorDialog',\n\tcomponents: {\n\t\tFieldPill\n\t},\n\tprops: {\n\t\tquill: {\n\t\t\tdefault: null\n\t\t},\n\t\tQuill: {\n\t\t\tdefault: null\n\t\t},\n\t\tdoctype: {\n\t\t\tdefault: null\n\t\t}\n\t},\n\tdata() {\n\t\treturn {\n\t\t\tfields: {},\n\t\t\tselectedPills: [],\n\t\t\treferenceDoc: null\n\t\t}\n\t},\n\tcreated() {\n\t\tfrappe.field_selector_updates.on('reference_update', (reference) => {\n\t\t\tthis.selectedPills = []\n\t\t\tthis.get_fields(reference)\n\t\t})\n\n\t\tfrappe.field_selector_updates.on('clear', () => {\n\t\t\tthis.selectedPills = []\n\t\t\tthis.fields = {}\n\t\t})\n\n\t\tfrappe.field_selector_updates.on('submit', () => {\n\t\t\tthis.add_field_to_text();\n\t\t\tfrappe.field_selector_updates.trigger('done');\n\t\t})\n\t},\n\tmounted() {\n\t\tif (this.doctype) {\n\t\t\tthis.referenceDoc = this.doctype;\n\t\t\tthis.get_fields(this.doctype)\n\t\t}\n\t},\n\tmethods: {\n\t\tget_fields(reference) {\n\t\t\tthis.referenceDoc = reference;\n\t\t\tfrappe.xcall('frappe.email.doctype.email_template.email_template.get_template_fields', {reference: reference})\n\t\t\t.then(e => {\n\t\t\t\tthis.fields = e\n\t\t\t})\n\t\t},\n\t\tadd_field_to_text() {\n\t\t\tlet range = this.quill.getSelection(true);\n\n\t\t\tthis.selectedPills.forEach(value => {\n\t\t\t\tthis.quill.insertEmbed(\n\t\t\t\t\trange.index,\n\t\t\t\t\t'template-blot',\n\t\t\t\t\t{\n\t\t\t\t\t\tparent: value.parent,\n\t\t\t\t\t\tfieldname: value.fieldname,\n\t\t\t\t\t\treference: value.reference,\n\t\t\t\t\t\tlabel: value.label,\n\t\t\t\t\t\tfunction: value.function,\n\t\t\t\t\t\tfieldtype: value.fieldtype\n\t\t\t\t\t}\n\t\t\t\t);\n\n\t\t\t\t//Add a space after the marker and take the cursor to the inserted blot\n\t\t\t\tthis.quill.insertText(range.index + 1, ' ', this.Quill.sources.USER);\n\t\t\t\tthis.quill.setSelection(range.index + 2, this.Quill.sources.SILENT);\n\t\t\t\t})\n\t\t},\n\t\tshowReference(field) {\n\t\t\treturn field==\"name\" ? true : false\n\t\t}\n\t}\n}\n\n</script>\n\n<style>\n\n.field-pill-wrapper {\n\tmargin: 5px;\n}\n\n.field-pill-section {\n\tpadding: 5px 0;\n}\n\n.field-pill-title {\n\tpadding-left: 10px;\n}\n\n.field-pill-section-wrapper {\n\tmargin-top: 30px;\n}\n\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frappe/public/js/frappe/form/controls/template_field_selector/TemplateFieldSelector.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__